<div class="system-status" *ngIf="overall$ | async as overall">

    <!--
      A BUTTON, not a hover target. The app ships under Capacitor on iPads and phones where hover
      does not exist, and a hover-only panel would make this decorative on exactly the devices used
      at the bedside. Hover opens it too on a pointer device, as an enhancement — and a panel opened
      that way closes again once the pointer leaves both the dot and the panel.
    -->
    <!--
      A PLAIN button, not `mat-button`. Material's button paints a state layer on hover, which put a
      grey rounded slab behind the dot — button chrome around a 10px indicator reads as a control
      that is doing something, when all it does is open a panel. The keyboard focus ring is kept
      explicitly in the SCSS, so dropping the state layer costs nothing for keyboard users.
    -->
    <button type="button"
        class="status-trigger"
        [matMenuTriggerFor]="statusMenu"
        #statusTrigger="matMenuTrigger"
        #statusButton
        (mouseenter)="openOnHover(statusTrigger, statusButton)"
        [attr.aria-label]="ariaLabel(overall)"
        [matTooltip]="tooltip(overall)">
        <!--
          Colour is NEVER the only signal: green/amber is the pairing that fails for the commonest
          form of colour blindness, so each state is drawn as a distinct shape as well, and the
          panel spells the state out in words.
        -->
        <span class="status-dot" [ngClass]="'status-' + overall" aria-hidden="true"></span>
    </button>

    <mat-menu #statusMenu="matMenu" xPosition="before" class="system-status-menu">
        <div class="status-panel" (click)="$event.stopPropagation()">

            <div class="status-panel-header" [ngClass]="'status-' + overall">
                <span class="status-dot" aria-hidden="true"></span>
                <span class="status-headline">{{ headline(overall) }}</span>
            </div>

            <mat-divider></mat-divider>

            <div class="status-list">
                <div class="status-row" *ngFor="let subsystem of subsystems$ | async"
                    [ngClass]="'status-' + rowStatus(subsystem, overall)">
                    <span class="status-dot" aria-hidden="true"></span>
                    <div class="status-row-body">
                        <div class="status-row-title">
                            <span class="status-row-label">{{ subsystem.label }}</span>
                            <!-- The word, not just the colour. -->
                            <span class="status-row-state">{{ stateLabel(rowStatus(subsystem, overall)) }}</span>
                        </div>

                        <!-- Hidden while unknown: we do not know the state, so we cannot advise a
                             workaround for it either. -->
                        <div class="status-row-detail"
                            *ngIf="overall !== 'unknown' && subsystem.status !== 'operational'">
                            <p class="status-message" *ngIf="subsystem.message">{{ subsystem.message }}</p>
                            <p class="status-workaround" *ngIf="subsystem.whenDegraded">{{ subsystem.whenDegraded }}</p>
                            <!--
                              "Degraded since 09:14" — the cheapest defence against a forgotten
                              toggle. It makes staleness visible to the people best placed to
                              notice it, which is the users.
                            -->
                            <p class="status-since" *ngIf="subsystem.since">Since {{ subsystem.since | date:'d MMM, HH:mm' }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <mat-divider></mat-divider>

            <!-- The honest limit, where users can see it. -->
            <p class="status-footnote" *ngIf="overall !== 'unknown'">
                Updated {{ checkedAtLabel }}. This shows MedicAI's own services — it cannot see your
                internet connection.
            </p>
            <p class="status-footnote status-footnote-unknown" *ngIf="overall === 'unknown'">
                We could not reach MedicAI to check — this may be your internet connection.
                Retrying automatically.
            </p>
        </div>
    </mat-menu>
</div>
